import { MercureContext } from "@app/providers/MercureProvider";
import { useContext } from "react";

export const useMercureContext = () => {
  const context = useContext(MercureContext);
  return context;
};

export default useMercureContext;
